import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
		meta: {
			title: 'Marcelino - Home',
		},
	},
	{
		path: '/about',
		name: 'About',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ '../views/About.vue'),
		meta: {
			title: 'Marcelino - About',
		},
	},
	{
		path: '/projects',
		name: 'Projects',
		// route level code-splitting
		// this generates a separate chunk (projects.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "projects" */ '../views/Projects.vue'),
		meta: {
			title: 'Marcelino - Projects',
		},
	},
	{
		path: '/projects/1',
		name: 'Instruo',
		// route level code-splitting
		// this generates a separate chunk (projects.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
				/* webpackChunkName: "projects" */ '../views/SingleProject.vue'
			),
		meta: {
			title: 'Marcelino - Instruo',
		},
	},
	{
		path: '/projects/2',
		name: 'MangaSlice',
		component: () =>
			import(
				'../views/MangaSlice.vue'
			),
		meta: {
			title: 'Marcelino - MangaSlice',
		},
	},
	{
		path: '/projects/3',
		name: 'Connectre-B',
		component: () =>
			import(
				'../views/Connectre-B.vue'
			),
		meta: {
			title: 'Marcelino - Connectre-B',
		},
	},
	{
		path: '/projects/4',
		name: 'Xperience',
		component: () =>
			import(
				'../views/Xperience.vue'
			),
		meta: {
			title: 'Marcelino - Xperience',
		},
	},
	{
		path: '/projects/5',
		name: 'GovAccess',
		component: () =>
			import(
				'../views/GovAccess.vue'
			),
		meta: {
			title: 'Marcelino - GovAccess',
		},
	},
	{
		path: '/projects/6',
		name: 'AugmentedFaces',
		component: () =>
			import(
				'../views/AugmentedFaces.vue'
			),
		meta: {
			title: 'Marcelino - AugmentedFaces',
		},
	},
	{
		path: '/projects/7',
		name: 'SoulSwipe',
		component: () =>
			import(
				'../views/SoulSwipe.vue'
			),
		meta: {
			title: 'Marcelino - SoulSwipe',
		},
	},
	{
		path: '/projects/8',
		name: 'Photo81',
		component: () =>
			import(
				'../views/Photo81.vue'
			),
		meta: {
			title: 'Marcelino - Photo81',
		},
	},
	{
		path: '/projects/9',
		name: 'TakedaCryptoLending',
		component: () =>
			import(
				'../views/TakedaCryptoLending.vue'
			),
		meta: {
			title: 'Marcelino - Takeda CryptoLending',
		},
	},
	{
		path: '/projects/10',
		name: 'Calcmenu',
		component: () =>
			import(
				'../views/Calcmenu.vue'
			),
		meta: {
			title: 'Marcelino - Calcmenu',
		},
	},
	{
		path: '/contact',
		name: 'Contact',
		// route level code-splitting
		// this generates a separate chunk (projects.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "projects" */ '../views/Contact.vue'),
		meta: {
			title: 'Marcelino - Contact',
		},
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
	scrollBehavior() {
		document.getElementById('app').scrollIntoView();
	},
});

export default router;

/**
 * Below code will display the component/active page title
 * Powered by: Nangialai Stoman
 */

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
	// This goes through the matched routes from last to first, finding the closest route with a title.
	// e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
	// `/nested`'s will be chosen.
	const nearestWithTitle = to.matched
		.slice()
		.reverse()
		.find((r) => r.meta && r.meta.title);

	// Find the nearest route element with meta tags.
	const nearestWithMeta = to.matched
		.slice()
		.reverse()
		.find((r) => r.meta && r.meta.metaTags);

	const previousNearestWithMeta = from.matched
		.slice()
		.reverse()
		.find((r) => r.meta && r.meta.metaTags);

	// If a route with a title was found, set the document (page) title to that value.
	if (nearestWithTitle) {
		document.title = nearestWithTitle.meta.title;
	} else if (previousNearestWithMeta) {
		document.title = previousNearestWithMeta.meta.title;
	}

	// Remove any stale meta tags from the document using the key attribute we set below.
	Array.from(
		document.querySelectorAll('[data-vue-router-controlled]')
	).map((el) => el.parentNode.removeChild(el));

	// Skip rendering meta tags if there are none.
	if (!nearestWithMeta) return next();

	// Turn the meta tag definitions into actual elements in the head.
	nearestWithMeta.meta.metaTags
		.map((tagDef) => {
			const tag = document.createElement('meta');

			Object.keys(tagDef).forEach((key) => {
				tag.setAttribute(key, tagDef[key]);
			});

			// We use this to track which meta tags we create so we don't interfere with other ones.
			tag.setAttribute('data-vue-router-controlled', '');

			return tag;
		})
		// Add the meta tags to the document head.
		.forEach((tag) => document.head.appendChild(tag));

	next();
});
